import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    close: {
        id: '_.processing_payment.modal.close',
        defaultMessage: 'Close'
    },
    paymentError: {
        id: '_.processing_payment.modal.payment_error',
        defaultMessage:
            'Unfortunately, we have not been able to process the payment.'
    }
});
